import { Component, OnInit } from '@angular/core';

import Language from '../../entities/language';
import { LanguageService } from '../../services/languages.service';
import { ActivatedRoute } from '@angular/router';
import { MobileService } from '../../services/mobile.service';

@Component({
    selector: 'tvl-system-languages-selector',
    templateUrl: './system-languages-selector.component.html',
    styleUrls: ['./system-languages-selector.component.scss'],
    standalone: false
})
export class SystemLanguagesSelectorComponent implements OnInit {
  isMobile: boolean;
  languages: Language[] = null;
  selectedLanguage: Language = null;

  constructor(
    private languageService: LanguageService,
    private activatedRoute: ActivatedRoute,
    private mobileService: MobileService
  ) {
    this.isMobile = this.mobileService.isMobileDevice() && !this.mobileService.isTabletDevice();
  }

  ngOnInit() {
    this.activatedRoute.queryParams.subscribe();

    this.languageService.systemLanguages.subscribe((systemLanguages) => {
      this.initLanguages(systemLanguages, this.languageService.clientLanguages.value);
    });

    this.languageService.clientLanguages.subscribe((clientLanguages) => {
      this.initLanguages(this.languageService.systemLanguages.value, clientLanguages);
    });

    this.languageService.selectedSystemLanguage.subscribe((language) => {
      if (language) {
        this.selectedLanguage = language;
      }
    });
  }

  changeLanguage(language: Language) {
    this.selectedLanguage = language;
    this.languageService.changeSystemLanguageAndPutToStore(language);
  }

  private initLanguages(systemLanguages: Language[], clientLanguages: Language[]) {
    const languageData =
      clientLanguages.length === 0
        ? systemLanguages
        : systemLanguages.filter((systemLanguage) =>
            clientLanguages.some((clientLanguage) => clientLanguage.id == systemLanguage.id)
          );

    this.languages = this.languageService.sortLanguages(languageData, 'nativeName');
  }
}
